import { useContext } from 'react';
import { areLegacyInvalidFields } from 'state/selectors/meta/static/utils';

import { InvalidFieldsContext } from '../contexts/InvalidFieldsContext';

/**
 * @deprecated Replaced with the useFieldValidationError hook inside the groupform component.
 * Should be removed with the "displayInvalidFieldsMessagesInFormsParis" feature.
 */
export function useIsFieldInvalid(fieldId: string, level?: 'error' | 'warning'): boolean {
  const invalidFields = useContext(InvalidFieldsContext);

  if (areLegacyInvalidFields(invalidFields)) {
    const { errors, warnings } = invalidFields;
    switch (level) {
      case 'error':
        return errors.includes(fieldId);
      case 'warning':
        return warnings.includes(fieldId);
      default:
        return errors.includes(fieldId) || warnings.includes(fieldId);
    }
  } else {
    return false;
  }
}
